import type {ElementType} from "react";
import {SlidersHorizontal} from "lucide-react";

import {ICONS} from "@/src/modules/routing/utils/constants";

/** Sidebar-aligned icons for dispatch desk property rule groups. */
const DISPATCH_FEATURE_ICONS: Record<string, ElementType> = {
  citations: ICONS.citations,
  safelistings: ICONS.safelistings,
  permanentparking: ICONS.permanentparking,
  permanent_parking: ICONS.permanentparking,
  storedvehicles: ICONS.storedvehicles,
  poolaccesslogs: ICONS.poolaccesslogs,
  tennisaccesslogs: ICONS.tennisaccesslogs,
  gymaccesslogs: ICONS.gymaccesslogs,
  recreationaccesslogs: ICONS.recreationaccesslogs,
  warnings: ICONS.warnings,
  vehicles: ICONS.vehicles,
  parkingenforcement: ICONS.parkingenforcement,
};

export function getDispatchFeatureIcon(featureKey: string): ElementType {
  const normalized = featureKey.trim().toLowerCase();
  return DISPATCH_FEATURE_ICONS[normalized] ?? SlidersHorizontal;
}
